import { getServerTime } from '@tencent/wphk-components-common/utils/server-time';
import dayjs from 'dayjs';

/** 标记回流弹窗今天是否曾经弹出 */

const returnDialogTodayMark = `RETURN-ACT-DIALOG-${dayjs(getServerTime()).format('YYYYMMDD')}`;

export const setReturnDialogMark = () => {
  localStorage.setItem(returnDialogTodayMark, '1');
};

export const getReturnDialogMark = () => {
  const mark = localStorage.getItem(returnDialogTodayMark);
  return mark === '1';
};
